'use strict';

let theme = {

    init: function () {
        //this.mobileOffcanvas();
        this.scrollCue();
        this.swiperSlider();
        this.smoothScrollToTop();
        this.mobileNav();
    },

    mobileNav: function () {
        const toggler = document.querySelector('.navbar-toggler');
        const collapse = document.getElementById('navbarToggler');

        if (toggler && collapse) {
            collapse.addEventListener('show.bs.collapse', () => {
                toggler.classList.add('open');
            });
            collapse.addEventListener('hide.bs.collapse', () => {
                toggler.classList.remove('open');
            });
        }
    },


    /**
     * Sub Menus
     * Enables multilevel dropdown
     */
    subMenu: () => {
        (function ($bs) {
            const CLASS_NAME = 'has-child-dropdown-show';
            $bs.Dropdown.prototype.toggle = function (_original) {
                return function () {
                    document.querySelectorAll('.' + CLASS_NAME).forEach(function (e) {
                        e.classList.remove(CLASS_NAME);
                    });
                    let dd = this._element.closest('.dropdown').parentNode.closest('.dropdown');
                    for (; dd && dd !== document; dd = dd.parentNode.closest('.dropdown')) {
                        dd.classList.add(CLASS_NAME);
                    }
                    return _original.call(this);
                }
            }($bs.Dropdown.prototype.toggle);
            document.querySelectorAll('.dropdown').forEach(function (dd) {
                dd.addEventListener('hide.bs.dropdown', function (e) {
                    if (this.classList.contains(CLASS_NAME)) {
                        this.classList.remove(CLASS_NAME);
                        e.preventDefault();
                    }
                    e.stopPropagation();
                });
            });
        })(bootstrap);
    },

    scrollCue: () => {
        scrollCue.init({
            interval: -400,
            duration: 700,
            percentage: 0.8
        });
        scrollCue.update();
    },
    /**
     * Swiper Slider
     * Enables carousels and sliders
     * Requires assets/js/vendor/swiper-bundle.min.js
     */

    swiperSlider: function () {


        const swiperMotors = document.querySelector('.swiper-motors');

        if (swiperMotors && typeof Swiper !== 'undefined') {
            try {
                const swiperMotors = new Swiper('.swiper-motors', {
                    slidesPerView: 1,
                    spaceBetween: 30,
                    centeredSlides: true,
                    watchSlidesProgress: true,
                    loop: true,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    breakpoints: {
                        480: {
                            slidesPerView: 1,
                            spaceBetween: 20,
                        },
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 20,
                        },
                        992: {
                            slidesPerView: 3,
                            spaceBetween: 50,
                        },
                        1200: {
                            slidesPerView: 4,
                            spaceBetween: 50,
                        },
                        1600: {
                            slidesPerView: 5,
                            spaceBetween: 50,
                        }
                    }

                });
            } catch (error) {
                console.error('Error initializing News Swiper:', error);
            }
        }

        const swiperLocations = document.querySelector('.swiper-locations');

        if (swiperLocations && typeof Swiper !== 'undefined') {
            try {
                const swiperLocations = new Swiper('.swiper-locations', {
                    slidesPerView: 1,
                    spaceBetween: 30,
                    loop: true,

                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    breakpoints: {
                        480: {
                            slidesPerView: 2,
                            spaceBetween: 20,
                        },
                        768: {
                            slidesPerView: 3,
                            spaceBetween: 20,
                        },
                        992: {
                            slidesPerView: 4,
                            spaceBetween: 20,
                        }
                    }

                });
            } catch (error) {
                console.error('Error initializing News Swiper:', error);
            }
        }



        const swiperSingleMotors = document.querySelector('.swiper-motors3');
        if (swiperSingleMotors && typeof Swiper !== 'undefined') {
            try {
                const swiperSingleMotors = new Swiper('.swiper-motors3', {
                    slidesPerView: 1,
                    spaceBetween: 30,
                    loop: true,

                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    breakpoints: {
                        480: {
                            slidesPerView: 2,
                            spaceBetween: 20,
                        },
                        768: {
                            slidesPerView: 3,
                            spaceBetween: 20,
                        },
                        992: {
                            slidesPerView: 4,
                            spaceBetween: 20,
                        }
                    }

                });
            } catch (error) {
                console.error('Error initializing News Swiper:', error);
            }
        }

    },


    smoothScrollToTop: function () {
        document.addEventListener('DOMContentLoaded', function () {
            const scrollToTopButton = document.getElementById('scrollToTop');

            if (!scrollToTopButton) return;

            scrollToTopButton.addEventListener('click', () => {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            });

            window.addEventListener('scroll', () => {
                if (window.scrollY > 300) {
                    scrollToTopButton.classList.add('visible');
                } else {
                    scrollToTopButton.classList.remove('visible');
                }
            });
        });
    },

    /**
     * GLightbox
     * Enables lightbox functionality
     * Requires assets/js/vendor/glightbox.js
     */

    lightbox: () => {
        const lightbox = GLightbox({
            selector: '*[data-glightbox]',
            touchNavigation: true,
            loop: false,
            zoomable: false,
            autoplayVideos: true,
            moreLength: 0,
            slideExtraAttributes: {
                poster: ''
            },
            plyr: {
                css: '',
                js: '',
                config: {
                    ratio: '',
                    fullscreen: {
                        enabled: false,
                        iosNative: false
                    },
                    youtube: {
                        noCookie: true,
                        rel: 0,
                        showinfo: 0,
                        iv_load_policy: 3
                    },
                    vimeo: {
                        byline: false,
                        portrait: false,
                        title: false,
                        transparent: false
                    }
                }
            },
        });
    },

}
theme.init();
